"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MACROREGIONS_MAP = exports.MacroRegion = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
const isoRegion_1 = require("./isoRegion");
/**
 * Country Code taken from https://github.com/umpirsky/country-list/blob/master/data/en/country.json
 */
exports.MacroRegion = (0, type_utils_1.makeEnum)({
    [isoRegion_1.IsoCountryCode.EU]: isoRegion_1.IsoCountryCode.EU,
});
exports.DEFAULT_MACROREGIONS_MAP = {
    [exports.MacroRegion.EU]: [
        isoRegion_1.IsoCountryCode.BE, // Belgium
        isoRegion_1.IsoCountryCode.GR, // Greece
        isoRegion_1.IsoCountryCode.LT, // Lithuania
        isoRegion_1.IsoCountryCode.PT, // Portugal
        isoRegion_1.IsoCountryCode.BG, // Bulgaria
        isoRegion_1.IsoCountryCode.ES, // Spain
        isoRegion_1.IsoCountryCode.LU, // Luxembourg
        isoRegion_1.IsoCountryCode.RO, // Romania
        isoRegion_1.IsoCountryCode.CZ, // Czech Republic
        isoRegion_1.IsoCountryCode.FR, // France
        isoRegion_1.IsoCountryCode.RE, // Reunion
        isoRegion_1.IsoCountryCode.GP, // Guadeloupe
        isoRegion_1.IsoCountryCode.MQ, // Martinique
        isoRegion_1.IsoCountryCode.GF, // French Guiana
        isoRegion_1.IsoCountryCode.YT, // Mayotte
        isoRegion_1.IsoCountryCode.BL, // Saint Barthelemy
        isoRegion_1.IsoCountryCode.MF, // Saint Martin
        isoRegion_1.IsoCountryCode.PM, // Saint Pierre and Miquelon
        isoRegion_1.IsoCountryCode.WF, // Wallis and Futuna
        isoRegion_1.IsoCountryCode.PF, // French Polynesia
        isoRegion_1.IsoCountryCode.NC, // New Caledonia
        isoRegion_1.IsoCountryCode.HU, // Hungary
        isoRegion_1.IsoCountryCode.SI, // Slovenia
        isoRegion_1.IsoCountryCode.DK, // Denmark
        isoRegion_1.IsoCountryCode.FO, // Faroe Islands
        isoRegion_1.IsoCountryCode.GL, // Greenland
        isoRegion_1.IsoCountryCode.HR, // Croatia
        isoRegion_1.IsoCountryCode.MT, // Malta
        isoRegion_1.IsoCountryCode.SK, // Slovakia
        isoRegion_1.IsoCountryCode.DE, // Germany
        isoRegion_1.IsoCountryCode.IT, // Italy
        isoRegion_1.IsoCountryCode.NL, // Netherlands
        isoRegion_1.IsoCountryCode.AW, // Aruba
        isoRegion_1.IsoCountryCode.CW, // Curacao
        isoRegion_1.IsoCountryCode.SX, // Sint Maarten
        isoRegion_1.IsoCountryCode.FI, // Finland
        isoRegion_1.IsoCountryCode.AX, // Aland Islands
        isoRegion_1.IsoCountryCode.EE, // Estonia
        isoRegion_1.IsoCountryCode.CY, // Cyprus
        isoRegion_1.IsoCountryCode.AT, // Austria
        isoRegion_1.IsoCountryCode.SE, // Sweden
        isoRegion_1.IsoCountryCode.IE, // Ireland
        isoRegion_1.IsoCountryCode.LV, // Latvia
        isoRegion_1.IsoCountryCode.PL, // Poland
        isoRegion_1.IsoCountryCode.AI, // Anguilla
        isoRegion_1.IsoCountryCode.BM, // Bermuda
        isoRegion_1.IsoCountryCode.IO, // British Indian Ocean Territory
        isoRegion_1.IsoCountryCode.VG, // British Virgin Islands
        isoRegion_1.IsoCountryCode.KY, // Cayman Islands
        isoRegion_1.IsoCountryCode.FK, // Falkland Islands
        isoRegion_1.IsoCountryCode.GI, // Gibraltar
        isoRegion_1.IsoCountryCode.MS, // Montserrat
        isoRegion_1.IsoCountryCode.PN, // Pitcairn, Henderson, Ducie and Oeno Islands
        isoRegion_1.IsoCountryCode.SH, // Saint Helena, Ascension and Tristan da Cunha
        isoRegion_1.IsoCountryCode.TC, // Turks and Caicos Islands
        isoRegion_1.IsoCountryCode.GG, // Guernsey
        isoRegion_1.IsoCountryCode.JE, // Jersey
        isoRegion_1.IsoCountryCode.IM, // Isle of Man
    ], // N.B. Does not include GB
};
//# sourceMappingURL=macroregion.js.map